import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { createMmscanI18n, type MmscanI18nFactory } from '@mmscan/angular-ui/core';

/** Strings rendered by the charts (in the screen-reader data table). */
export interface MmscanChartsI18n {
  /** Header of the label column. */
  category: string;
}

export const MMSCAN_CHARTS_I18N_DEFAULTS: MmscanChartsI18n = {
  category: 'Category',
};

const chartsI18n = createMmscanI18n<MmscanChartsI18n>('MMSCAN_CHARTS_I18N', MMSCAN_CHARTS_I18N_DEFAULTS);

export const MMSCAN_CHARTS_I18N = chartsI18n.token;

export interface MmscanChartsOptions {
  i18n?: MmscanI18nFactory<MmscanChartsI18n>;
}

export function provideMmscanCharts(options: MmscanChartsOptions = {}): EnvironmentProviders {
  return makeEnvironmentProviders(options.i18n ? [chartsI18n.provide(options.i18n)] : []);
}
